import React from 'react';
import { Handle, Position } from '@xyflow/react';
import Icon from '../../../ui/Icon';

export default function EventNode({ data }) {
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '1px solid #DDE1E7',
        borderRadius: 10,
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 180,
        maxWidth: 220,
        boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#3B5BDB',
          display: 'grid',
          placeItems: 'center',
          flexShrink: 0,
          boxShadow: '0 1px 4px rgba(22,163,74,0.35)',
        }}
      >
        <Icon name="check" size={16} color="#fff" />
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#1A202C', lineHeight: 1.3 }}>
        {data.label || 'Ticket is raised'}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{ width: 10, height: 10, background: '#718096', border: '2px solid #fff' }}
      />
    </div>
  );
}
